/** @jsxImportSource react */
import { Box, Grid, Typography } from "@mui/material";
import { StepProps } from "./types";
import { StyledTextField } from "./StyledComponents";

export const BusinessInformationStep: React.FC<StepProps> = ({ formik }) => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Business Information
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <StyledTextField
            fullWidth
            name="business_name"
            label="Business Name"
            value={formik.values.business_name}
            onChange={formik.handleChange}
            error={
              formik.touched.business_name &&
              Boolean(formik.errors.business_name)
            }
            helperText={
              formik.touched.business_name && formik.errors.business_name
            }
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <StyledTextField
            fullWidth
            name="owner.first_name"
            label="Owner First Name"
            value={formik.values.owner.first_name}
            onChange={formik.handleChange}
            error={
              formik.touched.owner?.first_name &&
              Boolean(formik.errors.owner?.first_name)
            }
            helperText={
              formik.touched.owner?.first_name &&
              formik.errors.owner?.first_name
            }
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <StyledTextField
            fullWidth
            name="owner.last_name"
            label="Owner Last Name"
            value={formik.values.owner.last_name}
            onChange={formik.handleChange}
            error={
              formik.touched.owner?.last_name &&
              Boolean(formik.errors.owner?.last_name)
            }
            helperText={
              formik.touched.owner?.last_name && formik.errors.owner?.last_name
            }
          />
        </Grid>
        <Grid item xs={12}>
          <StyledTextField
            fullWidth
            name="owner.email"
            label="Business Owner Email"
            type="email"
            value={formik.values.owner.email}
            onChange={formik.handleChange}
            error={
              formik.touched.owner?.email && Boolean(formik.errors.owner?.email)
            }
            helperText={
              formik.touched.owner?.email && formik.errors.owner?.email
            }
          />
        </Grid>
      </Grid>
    </Box>
  );
};
